export enum Role {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    Executive = "Executive",
    Teacher = "Teacher",
  }
  